<div
  attr.id="card-{{ cardPosition }}"
  class="cardContent"
  *ngIf="ready"
  [hidden]="card.isTemporarilyHidden"
  [ngClass]="{
    hasHeading: !(card.listeners.length && card.dismissListeners.length)
  }"
>
  <h4
    class="mw568 cardHeading ng-binding"
    dir="{{ dir$ | async }}"
    [innerHTML]="labelText"
  ></h4>
  <ng-container *ngIf="content && (isModal$ | async) === false">
    <app-content-repeater [items]="content"></app-content-repeater>
  </ng-container>
</div>
